/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from 'react'
import { NavLink, useLocation } from 'react-router-dom'

export const NavItem = ({
  to = '/',
  label = 'Label',
  icon = 'fas-fa-circle',
  multiLevel = false,
  id,
}) => {
  const location = useLocation()
  const [rotate, setRotate] = useState(false)

  const handleRotate = () => {
    setRotate(!rotate)
  }

  let isMatch = false

  if (multiLevel) {
    //-Si el path es multilevel agregandole una diagonal y concide con el "to" entonces aplicar match
    if (location?.pathname.includes(`${to}/`)) {
      isMatch = true
    }
  } else {
    //Se usa este RegExp para validar una concidencia exacta con el path
    const reg = new RegExp('^' + to + '$')

    if (location?.pathname.match(reg)) {
      isMatch = true
    }
  }

  return multiLevel ? (
    <>
      <li className={`nav-item multi-level`} onClick={() => handleRotate()}>
        <a
          href={`#Submenu${id}`}
          data-toggle="collapse"
          aria-expanded={isMatch ? 'true' : 'false'}
          className={`nav-link ${isMatch ? 'active' : ''}`}
        >
          <i className={`nav-icon ${icon}`}></i>
          <p className='text-migrates'>
            {label}
            <i
              className={
                rotate
                  ? 'ml-2 fas fa-angle-right toggle-up'
                  : 'ml-2 fas fa-angle-right toggle-down'
              }
            ></i>
          </p>
        </a>
        <ul
          className={`list-unstyled nav-item-list ${
            isMatch ? 'collapse show' : 'collapse'
          }`}
          id={`Submenu${id}`}
        >
          {multiLevel.map((item, idx) => (
            <li key={idx} className="nav-item">
              <NavLink
                exact
                to={item?.to}
                className={`nav-link nav-link-child`}
                activeClassName="active"
              >
                <i className={`${item.icon} nav-icon`}></i>
                <p className='text-migrates'>
                  {item?.label}
                  {item?.badge > 0 && (
                    <span className="badge badge-color right">
                      {item?.badge}
                    </span>
                  )}
                </p>
              </NavLink>
            </li>
          ))}
        </ul>
      </li>
    </>
  ) : (
    <li className="nav-item">
      <NavLink
        exact
        to={to}
        className={`nav-link ${isMatch && 'active'}`}
        activeClassName="active"
      >
        <i className={`nav-icon ${icon}`}></i>
        <p className='text-migrates'>{label}</p>
      </NavLink>
    </li>
  )
}

export default NavItem
